import { head, last } from 'lodash'

import { isBranded } from '@/helpers/isBranded'

const state = {
  title: 'Real Estate Virtual Tour Hosting Platform - HomeOnTour',
  ready: false,
  success: false,
  error: false,
  id: undefined,
  settings: {},
  photos: [],
  tour360: {
    matterport: false,
    iguide: false,
    cloudPano: false,
    matterportUrl: '',
    iguideUrl: '',
    cloudPanoUrl: ''
  },
  video: {
    isYoutube: false,
    isVimeo: false,
    isIframe: false,
    youtubeUrlBranded: '',
    youtubeUrlUnbranded: '',
    vimeoUrlBranded: '',
    vimeoUrlUnbranded: '',
    iframeUrlBranded: '',
    iframeUrlUnbranded: ''
  },
  address: {},
  fullAddress: undefined,
  walkScore: {},
  map: {},
  agent: {},
  details: {},
  floorplan: {},
  footer: {}
}

const getters = {
  getReady (state) {
    return state.ready
  },
  getPhotoByIndex (state) {
    return index => {
      return state.photos[index]
    }
  },
  getPhotosByLimit (state) {
    return (limit) => {
      return state.photos.slice(0, limit)
    }
  },
  getLayoutType (state) {
    const name = head(state.settings.layout.split('-'))

    if (name === 'scissors') {
      return 'multi'
    }

    return 'one'
  },
  getLayoutName (state) {
    const {layout} = state.settings

    if (layout) {
      return head(layout.split('-'))
    }

    return undefined
  },
  getThemeName (state) {
    const {layout} = state.settings

    if (layout) {
      return last(layout.split('-'))
    }

    return 'light'
  }
}

const mutations = {
  setTitle (state, title) {
    state.title = title
  },
  setReady (state) {
    state.ready = true
  },
  setSuccess (state) {
    state.success = true
  },
  setError (state) {
    state.error = true
  },
  setId (state, id) {
    state.id = id
  },
  setSettings (state, settings) {
    state.settings = settings
  },
  setPhotos (state, photos) {
    state.photos = photos
  },
  setTour360 (state, tour360) {
    state.tour360 = tour360
  },
  setVideo (state, video) {
    state.video = video
  },
  setAddress (state, address) {
    state.address = address
  },
  setFullAddress (state, fullAddress) {
    state.fullAddress = fullAddress
  },
  setWalkScore (state, walkScore) {
    state.walkScore = walkScore
  },
  setMap (state, map) {
    state.map = map
  },
  setAgent (state, agent) {
    state.agent = agent
  },
  setDetails (state, details) {
    state.details = details
  },
  setFloorplan (state, floorplan) {
    state.floorplan = floorplan
  },
  setFooter (state, footer) {
    state.footer = footer
  }
}

const actions = {
  getTourSuccess ({commit, dispatch}, data) {
    const {
      id,
      settings,
      photos,
      tour360,
      video,
      address,
      fullAddress,
      walkScore,
      map,
      agent,
      details,
      floorplan,
      footer
    } = data

    commit('setSuccess')
    commit('setId', id)
    commit('setSettings', settings)
    photos && commit('setPhotos', photos)
    tour360 && commit('setTour360', tour360)
    video && commit('setVideo', video)
    commit('setAddress', address)
    commit('setFullAddress', fullAddress)
    walkScore && commit('setWalkScore', walkScore)
    map && commit('setMap', map)
    agent && commit('setAgent', agent)
    details && commit('setDetails', details)
    floorplan && commit('setFloorplan', floorplan)
    footer && commit('setFooter', footer)

    dispatch('setReady')
  },
  getTourFailure ({commit, dispatch}) {
    commit('setError')
    dispatch('setReady')
  },
  setReady ({commit}) {
    setTimeout(() => {
      commit('setReady')

      const { fullAddress } = state

      if (!isBranded() && fullAddress) {
        commit('setTitle', fullAddress)
      }
    }, 2000)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
